import React from 'react';
import { ColumnDefinition, CoreRouterLink } from '@amzn/dots-core-ui';
import { Host } from '$/api';
import { HostStatusTag } from './HostStatusTag';
import { HostDetailUri } from '$/features/routes';

export const HostColumnDefinitions: ColumnDefinition<Host>[] = [
  {
    id: 'hostname',
    header: 'Hostname',
    item: ({ id, name }): JSX.Element => (
      <CoreRouterLink href={HostDetailUri(id)}>{name}</CoreRouterLink>
    ),
  },
  {
    id: 'status',
    header: 'Status',
    item: ({ status }): JSX.Element => <HostStatusTag status={status} />,
  },
  {
    id: 'version',
    header: 'Version',
    item: (host): string => host.version,
  },
  {
    id: 'owner',
    header: 'Owner',
    item: (host): string => host.owner,
  },
  {
    id: 'lab',
    header: 'Lab',
    item: (host): string => host.lab.name,
  },
  {
    id: 'location',
    header: 'Location',
    item: (host): string => host.lab.location.name,
  },
];
